package Structs

import Utils.TaxNoteType
import kotlinx.serialization.Serializable
import myName
import kotlin.math.abs


val epsilon = 2.5
val small_epsilon = 1

@Serializable
@myName("DebtWall")
data class DebtWall(val client: Int) {
    lateinit var year: String
    var taxNotes: List<ClientLightTaxNote> = listOf()
    var payNotes: List<ClientLightPay> = listOf()
    var taxPayNotes: List<ClientLightTaxNote> = listOf()
    var taxCancelNotes: List<ClientLightTaxNote> = listOf()
    var debts: MutableList<ClientCarteset> = mutableListOf()

    @myName("moneyOut")
    val moneyOut: Float
        get() {
            var s = taxNotes.sumOf { it.total_value.toDouble() }
            s += taxPayNotes.sumOf { it.total_value.toDouble() }
            s -= taxCancelNotes.sumOf { it.total_value.toDouble() }
            s += debts.sumOf { it.positive.toDouble() }
            return s.toFloat()
        }

    @myName("moneyIn")
    val moneyIn: Float
        get() {
            var s = payNotes.sumOf { it.value.toDouble() }
            s += taxPayNotes.sumOf {
                it.total_value.toDouble()
            }
            s += debts.sumOf { it.negative.toDouble() }

            return s.toFloat()
        }
    val taxPaid: Float
        get() {
            var s = taxNotes.sumOf { it.getTaxPaid().toDouble() }
            s += taxPayNotes.sumOf { it.getTaxPaid().toDouble() }
            s -= taxCancelNotes.sumOf { it.getTaxPaid().toDouble() }
            return s.toFloat()
        }
    fun empty(): Boolean {
        return taxNotes.isEmpty() && payNotes.isEmpty() && taxPayNotes.isEmpty() && taxCancelNotes.isEmpty() && debts.isEmpty()
    }
    fun onlyTaxSide(): Float {
        return totalDebt(onlyTaxSide = true, noCancel = true)
    }
    fun totalDebt(   onlyTaxSide: Boolean = false,noCancel: Boolean=false,open:Boolean=false): Float {
        if(onlyTaxSide){
            var s = taxNotes.filter { (!noCancel || it.isActive()) && (!open || !it.isUsed()) }.sumOf { if(open && onlyTaxSide) it.getOpenValue().toDouble()  else it.total_value.toDouble() }
            s += taxPayNotes.filter { (!noCancel || it.isActive()) && (!open || !it.isUsed()) }.sumOf {if(open && onlyTaxSide) it.getOpenValue().toDouble()  else it.total_value.toDouble()  }
            s -= taxCancelNotes.filter { (!noCancel || it.isActive()) && (!open || !it.isUsed()) }.sumOf {  it.total_value.toDouble()  }


            return s.toFloat()
        }
        return moneyOut - moneyIn
    }

    @myName("prepareCartesetList")
    fun prepareCartesetList(
        withSep: Boolean = false,
        onlyTaxSide: Boolean = false,
        reverse: Boolean = false,
        noCancel: Boolean = false,
        open: Boolean = false
    ): List<Pair<String, InformationBase>> {
        val map: MutableMap<String, MutableList<InformationBase>> = HashMap()
        taxNotes.forEach {
            if(open && (it.isUsed() || !it.isActive()) )
                return@forEach
            var doc = map[it.document_date]
            if (doc == null) {
                map[it.document_date] = mutableListOf()
                doc = map[it.document_date]
            }
            doc!!.add(it)

        }
        taxCancelNotes.forEach {
            if(open && (it.isUsed() || !it.isActive()) )
                return@forEach
            var doc = map[it.document_date]
            if (doc == null) {
                map[it.document_date] = mutableListOf()
                doc = map[it.document_date]
            }
            doc!!.add(it)

        }
        taxPayNotes.forEach {
            if(open && (it.isUsed() || !it.isActive()) )
                return@forEach
            var doc = map[it.document_date]
            if (doc == null) {
                map[it.document_date] = mutableListOf()
                doc = map[it.document_date]
            }
            doc!!.add(it)

        }
        if (!onlyTaxSide) {
            payNotes.forEach {
                var doc = map[it.document_date]
                if (doc == null) {
                    map[it.document_date] = mutableListOf()
                    doc = map[it.document_date]
                }
                doc!!.add(it)

            }
        }
        debts.forEach {
            // Tax-only carteset is invoices only: drop יתרת פתיחה and חוב ידני.
            if (onlyTaxSide) {
                return@forEach
            }
            var doc = map[it.date]
            if (doc == null) {
                map[it.date] = mutableListOf()
                doc = map[it.date]
            }
            doc!!.add(it)
        }
        if (noCancel) {
            map.forEach {
                val lst = it.value
                val notActive = lst.filter { !it.isActive() }
                val active = lst.filter { it.isActive() }.toMutableList()

                notActive.groupBy { it.getConnectedValue() }.forEach {
                    val positiveSum = it.value.sumOf { it.getConnectedValueReal().toDouble() }
                    val negativeSum = it.value.sumOf { it.getConnectedPayment().toDouble() }
                    if (abs(positiveSum - negativeSum) > epsilon) {
                        it.value.forEach {
                            active.add(it)
                        }
                    }

                }
                lst.clear()
                lst.addAll(active)

            }
        }

        val ll = map.map {
            it.value.map { p ->
                Pair(it.key, p)
            }
        }.flatten().sortedByDescending { it.second.getConnectedDocType() }
        var l = if (reverse) ll.reversed()
            .sortedBy { it.first }
            .toMutableList()
        else
            ll
                .sortedByDescending { it.first }
                .toMutableList()

        if (withSep) {
            var sum: Float = 0f
            val retL: MutableList<Pair<String, InformationBase>> = mutableListOf()
            l.reversed().forEach {
                when (val doc = it.second) {
                    is ClientLightTaxNote -> {
                        when (doc.taxNoteType) {
                            TaxNoteType.WITH_PAYMENT -> {

                            }

                            TaxNoteType.CANCEL -> {
                                sum -= doc.getConnectedValue()
                            }

                            else -> {
                                sum += doc.getConnectedValue()
                            }
                        }
                    }

                    is ClientLightPay -> {

                        sum -= doc.getConnectedValue()
                    }

                    is ClientCarteset -> {
                        sum += doc.positive - doc.negative

                    }
                }
                retL.add(it)
                if (abs(sum) < epsilon) {
                    retL.add(Pair("0", EmptyDoc(id = -2)))
                }
            }
            retL.reverse()

            retL.add(0, Pair("", EmptyDoc(id = -1)))
            return retL
        } else {
            l.add(0, Pair("", EmptyDoc(id = -1)))
            return l
        }


    }
}
